webpackJsonp([58411574672382],{

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__(8);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	__webpack_require__(80);
	
	var _Jumbotron = __webpack_require__(17);
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_Component) {
	  _inherits(ContactPage, _Component);
	
	  function ContactPage() {
	    _classCallCheck(this, ContactPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ContactPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "ContactPage" },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Contact | " + _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_Jumbotron2.default, { message: "Contact Us" }),
	      _react2.default.createElement(
	        "div",
	        { className: "ContactPage__content Container" },
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "b",
	            null,
	            "Terribly Sorry Studios"
	          ),
	          _react2.default.createElement("br", null),
	          "20 Camden Street",
	          _react2.default.createElement("br", null),
	          "Suite 200",
	          _react2.default.createElement("br", null),
	          "Toronto, ON",
	          _react2.default.createElement("br", null),
	          "M5V 1V1",
	          _react2.default.createElement("br", null),
	          "Canada"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "info@sorrystudios.com",
	          _react2.default.createElement("br", null)
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "1 (855) 699-3825",
	          _react2.default.createElement("br", null)
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "1 (647) 493-3825",
	          _react2.default.createElement("br", null)
	        )
	      )
	    );
	  };
	
	  return ContactPage;
	}(_react.Component);
	
	exports.default = ContactPage;
	module.exports = exports["default"];

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-jsx-468ef272a5c7af9181f2.js